<!-- CallIndex.vue -->
<template>
    <main role="main">
        <!-- Sección de breadcrumb -->
        <call-breadcrumb></call-breadcrumb>
        <section class="has-background-grey p-5">
            <div class="container is-max-desktop">
                <div class="columns is-multiline">
                    <div class="column">
                        <header>
                            <h1 class="has-gob-title" tabindex="0">Call Center 101</h1>
                            <span class="is-lower-text-title" tabindex="0">Comunícate con nosotros vía
                                telefónica.</span>
                        </header>
                    </div>
                </div>
            </div>
        </section>
        <section class="px-5">
            <div class="container is-max-desktop pb-5">
                <div class="columns">
                    <div class="column is-8">
                        <p class="mb-3 mt-5" tabindex="0">Llámanos al <span
                                class="is-hidden-mobile"><strong>101</strong></span>
                            <strong><a href="tel:101" class="is-hidden-tablet is-underlined">101</a></strong> si
                            necesitas
                            <strong>orientación sobre
                                trámites
                                y servicios del Estado</strong>. También podemos entregarte <strong>información
                                personalizada</strong> sobre los beneficios del Instituto de Previsión Social (IPS)
                            y de
                            otras instituciones públicas.
                        </p>
                        <p tabindex="0"><strong>Si estás en el extranjero</strong>, comunícate al
                            <span class="is-hidden-mobile"><strong>+56 2 2965 40 00.</strong></span>
                        <div class="is-hidden-tablet">
                            <a href="tel:+56229654000" class="has-text-weight-bold is-underlined	">+56 2 2965 40 00</a>.
                        </div>
                        </p>
                    </div>
                </div>

                <div class="columns is-multiline">
                    <div class="column is-8">
                        <div class="msg msg-info mb-5" role="alert" aria-label="Horario de Atención">
                            <p class="mb-1" tabindex="0">
                                <strong>Horario de atención</strong>
                            </p>
                            <p tabindex="0" v-for="(horario, index) in horarios" :key="index"
                                v-html="formatHorario(horario)"></p>
                        </div>
                        <div v-if="mensaje" class="msg msg-warning mb-5" role="alert" aria-label="Contingencia">
                            <p tabindex="0">{{ mensaje }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </main>
</template>
<script>
import CallBreadcrumb from './components/CallBreadcrumb.vue';

export default {
    props: {
        callCenter: {
            type: Array,
            required: true
        },
    },
    components: {
        CallBreadcrumb
    },
    computed: {
        horarios() {
            const activeItem = this.callCenter.find(item => item.activo && item.horario);
            if (!activeItem || !activeItem.horario) return [];

            try {
                if (typeof activeItem.horario === 'string') {
                    return JSON.parse(activeItem.horario);
                }
                return activeItem.horario;
            } catch (e) {
                console.error("Error al parsear horarios.");
                return [];
            }
        },
        mensaje() {
            const messageItem = this.callCenter.find(item => item.mensaje !== null && item.activo);
            return messageItem ? messageItem.mensaje : null;
        }
    },
    methods: {
        diasEnEspanol(dias) {
            const diasMap = {
                monday: 'Lunes',
                tuesday: 'Martes',
                wednesday: 'Miércoles',
                thursday: 'Jueves',
                friday: 'Viernes',
                saturday: 'Sábado',
                sunday: 'Domingo'
            };

            return dias.map(dia => diasMap[dia] || dia);
        },

        formatHorario(horario) {
            if (!horario || !horario.dayOfWeek || !Array.isArray(horario.dayOfWeek)) {
                return '';
            }

            const dias = this.diasEnEspanol(horario.dayOfWeek);

            // Formatear los días según la cantidad
            let textoFormateado = '';

            if (dias.length === 1) {
                textoFormateado = dias[0];
            } else if (dias.length === 2) {
                textoFormateado = `${dias[0]} y ${dias[1].toLowerCase()}`;
            } else if (dias.length > 2) {
                // Si son días consecutivos (por ejemplo, Lunes a Viernes)
                const esConsecutivo = this.esDiasConsecutivos(horario.dayOfWeek);

                if (esConsecutivo) {
                    textoFormateado = `${dias[0]} a ${dias[dias.length - 1].toLowerCase()}`;
                } else {
                    // Días no consecutivos
                    const diasCopia = [...dias];
                    const ultimoDia = diasCopia.pop();
                    const diasEnMinuscula = diasCopia.map(dia => dia.toLowerCase());
                    const primerDia = diasEnMinuscula[0].charAt(0).toUpperCase() + diasEnMinuscula[0].slice(1);
                    diasEnMinuscula[0] = primerDia;
                    textoFormateado = `${diasEnMinuscula.join(', ')} y ${ultimoDia.toLowerCase()}`;
                }
            }

            // Formatear las horas eliminando ceros iniciales para horas entre 1 y 9
            const formatearHora = (hora) => {
                const [h, m] = hora.split(':');
                return (h.length === 2 && h[0] === '0' && h[1] !== '0') ? `${parseInt(h)}:${m}` : hora;
            };

            // Agregar las horas con formato strong
            return `${textoFormateado}, de <strong>${formatearHora(horario.opens)} a ${formatearHora(horario.closes)} hrs.</strong>`;
        },

        esDiasConsecutivos(diasArray) {
            // Mapear los días a números para verificar si son consecutivos
            const ordenDias = {
                'monday': 1,
                'tuesday': 2,
                'wednesday': 3,
                'thursday': 4,
                'friday': 5,
                'saturday': 6,
                'sunday': 7
            };

            // Ordenar los días por su número
            const diasOrdenados = [...diasArray].sort((a, b) => ordenDias[a] - ordenDias[b]);

            // Verificar si los días son consecutivos
            for (let i = 0; i < diasOrdenados.length - 1; i++) {
                if (ordenDias[diasOrdenados[i + 1]] - ordenDias[diasOrdenados[i]] !== 1) {
                    return false;
                }
            }

            return true;
        }
    }
}
</script>